/**
 * EsconderMotorista
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {EsconderMotoristaCollection} from '@/model/collection/EsconderMotoristaCollection'

/* TODO: review generated class */
export class EsconderMotorista extends Resource {
  idEsconderMotoristaPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  data: string | null = null

  get $id() {
    return this.idEsconderMotoristaPk
  }
  set $id(val) {
    this.idEsconderMotoristaPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of EsconderMotorista
   */
  async getEsconderMotorista(id: number) {
    return await Request.get(`/admin/esconder-motorista/${id}`)
      .name('getEsconderMotorista')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of EsconderMotorista
   */
  static async listEsconderMotorista(params: any) {
    return await Request.get(`/admin/esconder-motorista`, {params})
      .name('listEsconderMotorista')
      .as(EsconderMotoristaCollection)
      .getData()
  }

  /**
   * Persists a new instance of EsconderMotorista. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistEsconderMotorista() {
    return await Request.post(`/admin/esconder-motorista`, this)
      .name('persistEsconderMotorista')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of EsconderMotorista to use it in a CSV file
   */
  static async listCsvEsconderMotorista(params: any) {
    return await Request.get(`/admin/esconder-motorista/csv`, {params})
      .name('listCsvEsconderMotorista')
      .as(EsconderMotoristaCollection)
      .getData()
  }
}
